module.exports = __webpack_public_path__ + "img/caio-monteiro-zombie-shark-fight.5334498c.jpg";